export default __webpack_public_path__ + "static/media/banner-reference.c1cf0be1.png";